/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_Theme_WordsInputs */

const en_us2_search_field_theme_words = /** @type {(inputs: Search_Field_Theme_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`theme dark light mode night appearance colour color`)
};

const pt_br2_search_field_theme_words = /** @type {(inputs: Search_Field_Theme_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tema escuro claro dark modo noturno aparencia cor`)
};

const es_419_search_field_theme_words = /** @type {(inputs: Search_Field_Theme_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tema oscuro claro dark modo nocturno apariencia color`)
};

const pt_pt2_search_field_theme_words = /** @type {(inputs: Search_Field_Theme_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tema escuro claro dark modo noturno aspeto cor`)
};

const fr_fr2_search_field_theme_words = /** @type {(inputs: Search_Field_Theme_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`theme sombre clair dark mode nuit apparence couleur`)
};

const de_de2_search_field_theme_words = /** @type {(inputs: Search_Field_Theme_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`design theme dunkel hell modus nacht darstellung farbe`)
};

const it_it2_search_field_theme_words = /** @type {(inputs: Search_Field_Theme_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tema scuro chiaro dark modalita notte aspetto colore`)
};

/**
* | output |
* | --- |
* | "theme dark light mode night appearance colour color" |
*
* @param {Search_Field_Theme_WordsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_theme_words = /** @type {((inputs?: Search_Field_Theme_WordsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_Theme_WordsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_theme_words(inputs)
	if (locale === "es-419") return es_419_search_field_theme_words(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_theme_words(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_theme_words(inputs)
	if (locale === "de-DE") return de_de2_search_field_theme_words(inputs)
	if (locale === "it-IT") return it_it2_search_field_theme_words(inputs)
	return en_us2_search_field_theme_words(inputs)
});
export { search_field_theme_words as "search.field_theme_words" }